import { render } from "./AddOnSurvey.vue?vue&type=template&id=40cd02dc"
import script from "./AddOnSurvey.vue?vue&type=script&lang=js"
export * from "./AddOnSurvey.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__